// Formato del cambio contra la semana pasada que comparte el Home. Puro.

/** Dirección del delta contra la semana pasada; ±5% es la zona plana del mockup. */
export function deltaDirection(change: number | null): 'up' | 'down' | 'flat' | 'unknown' {
    if (change === null) return 'unknown';
    if (change > 0.05) return 'up';
    if (change < -0.05) return 'down';
    return 'flat';
}

/** `+12%` / `-8%` / `—`. El signo explícito en el positivo es del mockup. */
export function formatDelta(change: number | null): string {
    if (change === null) return '—';
    const pct = Math.round(change * 100);
    return `${pct >= 0 ? '+' : ''}${String(pct)}%`;
}
